import { render, staticRenderFns } from "./costs-tooltip.vue?vue&type=template&id=33512a8c&scoped=true"
import script from "./costs-tooltip.vue?vue&type=script&lang=ts"
export * from "./costs-tooltip.vue?vue&type=script&lang=ts"
import style0 from "./costs-tooltip.vue?vue&type=style&index=0&id=33512a8c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33512a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33512a8c')) {
      api.createRecord('33512a8c', component.options)
    } else {
      api.reload('33512a8c', component.options)
    }
    module.hot.accept("./costs-tooltip.vue?vue&type=template&id=33512a8c&scoped=true", function () {
      api.rerender('33512a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/common/costs-tooltip.vue"
export default component.exports